/**
 * `<value><unit>`, or the fallback when there is no value — `undefined` by
 * default, which leaves the custom property unset.
 *
 * Takes any unit, not only this mixin's `px | %`: a block's width is in `vw` and
 * its height in `vh`, and they format the same way.
 */
export function numberWithUnitVar(length: { value: number; unit: string } | null | undefined): string | undefined;
export function numberWithUnitVar(length: { value: number; unit: string } | null | undefined, fallback: string): string;
export function numberWithUnitVar(
    length: { value: number; unit: string } | null | undefined,
    fallback?: string
): string | undefined {
    return length ? `${length.value}${length.unit}` : fallback;
}

/** `<value>px`, or the fallback — `undefined` by default — when there is no value. */
export function pxVar(value: number | null | undefined): string | undefined;
export function pxVar(value: number | null | undefined, fallback: string): string;
export function pxVar(value: number | null | undefined, fallback?: string): string | undefined {
    return value == null ? fallback : `${value}px`;
}
